import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BIconChevronDown } from 'bootstrap-icons-vue'
import { Modal } from 'bootstrap'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClone } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faClone)

import 'bootstrap/scss/bootstrap.scss'
import './styles/global.scss'

createApp(App)
.component('BIconChevronDown', BIconChevronDown)
.component("Modal", Modal)
.component('font-awesome-icon', FontAwesomeIcon)
.use(VueAxios, axios)
.mount('#app')